<template>
  <div class="container-fluid">
    <v-data-table
      :headers="headers"
      :items="foods"
      sort-by="internalName"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      :loading="loading"
    >
      <template v-slot:top>
        <v-card
          color="red"
          flat
          tile
        >
          <v-toolbar dense
                     src="https://www.arcgis.com/sharing/rest/content/items/8f762395cd204552bb958ecb1b54339d/resources/1588745514029.jpeg?w=2932"
          >
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Archiv jídel</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          class="mr-2"
          @click="extract(item)"
        >
          mdi-archive-arrow-up
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getFood">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  Name: 'FoodDatabase',
  data: () => ({
    search: '',
    foods: [],
    loading: true,
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název jídla', value: 'name' },
      { text: 'Typ stravy', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Hmostost', value: 'weight' },
      { text: 'Kalorie', value: 'calories' },
      { text: 'Archivováno dne', value: 'archivedAt' },
      { text: 'Akce', value: 'actions', sortable: false }
    ]
  }),
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.getFood()
    },
    getFood () {
      this.loading = true
      this.$http.get('/admin/foods/archive')
        .then(response => {
          this.foods = this.keysToCamelCase(response.data)
            .filter(item => item.visible)
            .map(food => {
              food.timesStr = food.timeTypes
                .map(time => time.name)
                .join(', ')
              food.typesStr = food.foodTypes
                .map(type => type.name)
                .join(', ')
              food.alergensStr = food.alergens
                .map(alergen => alergen.name)
                .join(', ')
              food.archivedAt = food.updatedAt.slice(0, 10)
              return food
            })
          this.loading = false
        })
    },
    extract (item) {
      this.$http.post(`admin/foods/${item.id}/extract`)
        .then(() => {
          this.getFood()
        })
    }
  }
}
</script>

<style scoped>

</style>
